import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_CAMPAIGN,
  DELETE_CAMPAIGN,
  UPDATE_CAMPAIGN,
  ADD_NEW_CAMPAIGN,
} from "./actionType";

import {
  getCampaignSuccess,
  getCampaignFail,
  deleteCampaignSuccess,
  deleteCampaignFail,
  updateCampaignSuccess,
  updateCampaignFail,
  addCampaignSuccess,
  addCampaignFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveCampaignApi,
  getCampaignApi,
  updateCampaignApi,
  deleteCampaignApi,
  addNewCampaignApi
} from "../../helpers/backend_helper";

function* getCampaign({ payload: campaign }) {
  try {
    const response = yield call(getCampaignApi, campaign);
    yield put(getCampaignSuccess(GET_CAMPAIGN, response.data));
  } catch (error) {
    yield put(getCampaignFail(GET_CAMPAIGN, error));
  }
}

function* onUpdateCampaign({ payload: campaign }) {
  try {
    if (campaign.setApprove) {
      const response = yield call(approveCampaignApi, campaign);
      yield put(updateCampaignSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateCampaignApi, campaign);
      yield put(updateCampaignSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateCampaignFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteCampaign({ payload: campaign }) {
  try {
    const response = yield call(deleteCampaignApi, campaign);
    yield put(deleteCampaignSuccess({ campaign, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteCampaignFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewCampaign({ payload: campaign }) {
  try {
    const response = yield call(addNewCampaignApi, campaign);
    yield put(addCampaignSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addCampaignFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetCampaign() {
  yield takeEvery(GET_CAMPAIGN, getCampaign);
}

export function* watchUpdateCampaign() {
  yield takeEvery(UPDATE_CAMPAIGN, onUpdateCampaign);
}

export function* watchDeleteCampaign() {
  yield takeEvery(DELETE_CAMPAIGN, onDeleteCampaign);
}

export function* watchAddNewCampaign() {
  yield takeEvery(ADD_NEW_CAMPAIGN, onAddNewCampaign);
}

function* campaignSaga() {
  yield all([
    fork(watchGetCampaign),
    fork(watchDeleteCampaign),
    fork(watchUpdateCampaign),
    fork(watchAddNewCampaign)
  ]);
}

export default campaignSaga;
